import { render } from "./com-select-city.vue?vue&type=template&id=14ac6558"
import script from "./com-select-city.vue?vue&type=script&lang=js"
export * from "./com-select-city.vue?vue&type=script&lang=js"
script.render = render

export default script